<template>
  <AppView
    padd-bottom
  >

    <template v-slot:top-app-view>
      <transition name="fade" mode="out-in" appear>
        <!-- // * not using CompanyHeader because of companyLogo data -->
        <TopNav
          type="back"
          :prev-route="{ name: (isSuperAdmin ? 'viewCompany' : 'myLicense'), params: { id: $route.params.id } }"
          :title="company.company || 'fetching company...'"
          :title-class="[
            'tw-ml-8',
            { 'opacity-78 font-title tw-text-xl tw-tracking-wider tw-leading-6': !loadingCompany },
            { 'opacity-31 tw-italic tw-lowercase': loadingCompany },
          ]"
        >
          <template v-slot:title-left v-if="!loadingCompany">
            <UserPhoto
              :photo="company.logo"
              :user-name="{
                name: company.company,
              }"
              logo
              photo-size="tw-h-12 tw-w-12"
              :class="[
                'tw-mr-6 tw-my-1 tw-rounded-10--force --force-children tw-bg-app-white-87',
                { 'tw-shadow-app-sm': !(company.logo || '').length }
              ]"
            />
          </template>
        </TopNav>
      </transition>
    </template>

    <transition name="fade" mode="out-in" appear>

      <div v-if="errorCompany || errorCompanyProgram" class="tw-mt-12" key="errmsg">
        <p class="tw-py-12 tw-text-base tw-text-center" v-html="errorCompany || errorCompanyProgram"></p>
      </div>

      <div v-else-if="loadingCompany || loadingCompanyProgram" class="tw-mt-12" key="lodng">
        <p class="tw-py-12 tw-text-base tw-text-center">Loading...</p>
      </div>

      <div v-else key="bdy">
        <transition name="fade" mode="out-in" appear>

          <div class="app-view-grid px-body">
            <div class="app-view-grid__col-74">
              <div class="tw-flex tw-items-center">
                <UserPhoto
                  :photo="activeCompanyProgram.logo"
                  :user-name="{
                    name: activeCompanyProgram.name,
                  }"
                  logo
                  photo-size="tw-h-10 tw-w-10"
                  :class="[
                    'tw-rounded-10--force --force-children tw-bg-app-white-87 tw-mx-2',
                    { 'tw-shadow-app-sm': !(activeCompanyProgram.logo || '').length }
                  ]"
                />

                <p class="tw-font-bold">
                  {{ activeCompanyProgram.name }} Mentorship Program
                </p>

                <div class="tw-ml-auto">
                  <BaseButton
                    text="Delete Program"
                    class="tw-bg-red-500 tw-text-white tw-border-0"
                    @click="deleteProgram"
                />
                </div>
              </div>

              <!-- LOOK & FEEL (logo, color) -->
              <template>
                <div class="tw-flex tw-items-center tw-pt-10 tw-pb-3">
                  <h3 class="font-title tw-text-xl tw-tracking-wider">
                    Program Appearance
                  </h3>
                </div>
                <div class="tw-border-t tw-border-app-black-11 tw-mb-6"></div>
                <div></div>

                <div class="tw-flex tw-py-6 tw-flex-no-wrap">
                  <!-- logo -->
                  <div class="tw-px-8 tw-pb-8">
                    <!-- company logo -->
                    <p class="tw-font-bold opacity-78 leading-19 tw-text-base tw-mb-4">Program Logo</p>

                    <CompanyProgramLogo
                      :company-program="activeCompanyProgram"
                      @saved="programLogoSaved"
                    />
                  </div>

                  <!-- theme -->
                  <div class="tw-px-8 tw-pb-8" style="max-width: 220px;">
                    <!-- theme -->
                    <p class="tw-font-bold opacity-78 leading-19 tw-text-base">
                      Program Color Theme
                    </p>

                    <div class="tw-mt-4">
                      <template v-if="editingColor">
                        <EditCompanyProgramColor
                          class="tw-max-w-md"
                          :company-program="activeCompanyProgram"
                          @cancel-editing="editingColor = false"
                          @color-saved="programColorsSaved"
                        />
                      </template>
                      <template v-if="!editingColor">
                        <div>
                          <span class="tw-inline-block tw-border-2 tw-border-white tw-rounded-full w-56 h-56" :style="`background-color: ${activeCompanyProgram.color};`"></span>
                          <span class="tw-inline-block tw-border-2 tw-border-white tw-rounded-full tw-w-10 tw-h-10" :style="`background-color: ${activeCompanyProgram.color2};`"></span>
                        </div>
                        <BaseButton
                          text="Edit"
                          class="tw-border-0 tw-bg-app-black-11"
                          @click="editingColor = true;"
                        />
                      </template>
                    </div>
                  </div>
                </div>

                <div class="tw-flex tw-items-center tw-pt-10 tw-pb-3">
                  <h3 class="font-title tw-text-xl tw-tracking-wider">
                    Program Details
                  </h3>
                </div>
                <div class="tw-border-t tw-border-app-black-11 tw-mb-6"></div>
                <div></div>

                <div class="tw-py-6">
                  <div class="tw-mb-4 tw-inline-flex tw-items-center tw-gap-2">
                    <p class="tw-inline-block tw-mr-2">STATUS: {{companyProgramStatus}}</p>
                    <BaseButton
                      text="Deactivate"
                      class=""
                      v-if="Number(activeCompanyProgram.status) === programStatuses.active"
                      @click="deactivateProgram"
                      :disabled="isRunningProcess"
                    />
                    <BaseButton
                      text="Archive"
                      class="tw-bg-yellow-200 tw-border-yellow-800"
                      v-if="Number(activeCompanyProgram.status) !== programStatuses.ended"
                      confirm
                      confirm-message="Are you sure you want to archive this program?"
                      @click="archiveProgram"
                      :disabled="isRunningProcess"
                    />
                    <BaseButton
                      text="Activate"
                      class=""
                      v-if="Number(activeCompanyProgram.status) === programStatuses.deactivated || Number(activeCompanyProgram.status) === programStatuses.inactive || Number(activeCompanyProgram.status) === programStatuses.ended"
                      @click="activateProgram"
                      :disabled="isRunningProcess"
                    />
                  </div>
                  <div class="tw-mb-4">
                    <div class="tw-inline-flex tw-items-center">
                      <p class="tw-inline-block">Name:</p>
                      <template v-if="editingName">
                        <EditCompanyProgramName
                          :company-program="activeCompanyProgram"
                          @cancel-editing="editingName = false"
                          @name-saved="programNameSaved"
                        />
                      </template>
                      <template v-if="!editingName">
                        <p class="tw-pl-2 tw-pr-4">{{ activeCompanyProgram.name }}</p>
                        <BaseButton
                          text="Edit"
                          class="tw-border-0 tw-bg-app-black-11"
                          @click="editingName = true;"
                        />
                      </template>
                    </div>
                  </div>
                  <div class="tw-mb-4">
                    <div class="tw-inline-flex tw-items-center">
                      <p class="tw-inline-block">Description:</p>
                      <template v-if="editingDescription">
                        <EditCompanyProgramDescription
                          class="tw-max-w-md"
                          :company-program="activeCompanyProgram"
                          @cancel-editing="editingDescription = false"
                          @description-saved="programDescriptionSaved"
                        />
                      </template>
                      <template v-if="!editingDescription">
                        <p class="tw-pl-2 tw-pr-4 tw-max-w-md" v-html="activeCompanyProgram.description"></p>
                        <BaseButton
                          text="Edit"
                          class="tw-border-0 tw-bg-app-black-11"
                          @click="editingDescription = true;"
                        />
                      </template>
                    </div>
                  </div>
                  <div class="tw-mb-4">
                    <div class="tw-inline-flex tw-items-center">
                      <p class="tw-inline-block">Program Start date:</p>
                      <template v-if="editProgramStartDate">
                        <EditCompanyProgramDate
                          date-type="start"
                          :company-program="activeCompanyProgram"
                          @cancel-editing="editProgramStartDate = false"
                          @date-saved="programDateSaved"
                        />
                      </template>
                      <template v-if="!editProgramStartDate">
                        <p class="tw-pl-2 tw-pr-4 tw-max-w-md">
                          {{ activeCompanyProgram.start }}
                        </p>
                        <BaseButton
                          text="Edit"
                          class="tw-border-0 tw-bg-app-black-11"
                          @click="editProgramStartDate = true;"
                        />
                      </template>
                    </div>
                  </div>
                  <div class="tw-mb-4">
                    <p v-if="!programDateRangeIsValid" class="tw-text-red-500 tw-text-sm tw-font-bold">
                      Date range is invalid and will cause issues to the running of the program.<br/>
                      Please ensure <u>start date</u> is before <u>end date</u>
                    </p>
                  </div>
                  <div class="tw-mb-4">
                    <div class="tw-inline-flex tw-items-center">
                      <p class="tw-inline-block">Program End date:</p>
                      <template v-if="editProgramEndDate">
                        <EditCompanyProgramDate
                          date-type="end"
                          :company-program="activeCompanyProgram"
                          @cancel-editing="editProgramEndDate = false"
                          @date-saved="programDateSaved"
                        />
                      </template>
                      <template v-if="!editProgramEndDate">
                        <p class="tw-pl-2 tw-pr-4 tw-max-w-md">
                          {{ activeCompanyProgram.end }}
                        </p>
                        <BaseButton
                          text="Edit"
                          class="tw-border-0 tw-bg-app-black-11"
                          @click="editProgramEndDate = true;"
                        />
                      </template>
                    </div>
                  </div>
                </div>

              </template>

              <!-- SUPPORT ADMIN -->
              <template>
                <div class="tw-flex tw-items-center tw-pt-10 tw-pb-3">
                  <h3 class="font-title tw-text-xl tw-tracking-wider">
                    Support Admins
                  </h3>
                </div>
                <div class="tw-border-t tw-border-app-black-11 tw-mb-6"></div>
                <div></div>

                <div>
                  <ProgramSupportAdmins
                    :company="company"
                    :program="activeCompanyProgram"
                  />
                </div>
              </template>

              <!-- MENTORSHIP JOURNEYS -->
              <template>
                <portal to="modal-body" key="mdl">
                  <EditJourney
                    :company="company"
                    :company-program="activeCompanyProgram"
                    @created-success="closeModal(); getCompanyProgramJourneys(undefined, undefined, true);"
                  />
                </portal>

                <div class="tw-flex tw-items-center tw-pt-12 tw-pb-4">
                  <img
                    data-src="/img/edit-goals.png"
                    src="/img/mentorship-settings.png"
                    style="width: 80px; height: 80px;"
                    class="tw-object-cover tw-block tw-mr-8"
                    async
                  >
                  <h3 class="font-title tw-text-xl tw-tracking-wider">
                    Mentorship Journeys
                  </h3>

                  <BaseButton
                    text="Create A Program Journey"
                    class="tw-ml-auto"
                    @click="promptCreateProgramJourney"
                  />
                </div>
                <div class="tw-border-t tw-border-app-black-11 tw-mb-8"></div>
                <div class="tw-flex tw-flex-wrap stacked-grid stacked-grid--stack-four lg:stacked-grid--stack-four">
                  <!-- journeys list -->
                  <template v-for="(journey, index) in companyProgramJourneys">
                    <BaseCard :key="index" class="tw-border-- --tw-border-app-primary-blue info-card">
                      <h4 class="tw-text-xl font-title tw-px-2 tw-py-4">{{journey.title}}</h4>

                      <div class="tw-text-right tw-mt-3 tw-w-full tw-px-2 tw-pb-4">
                        <BaseButton
                          text="View Journey"
                          :to="{ name: 'customizeCompanyProgramJourney', params: { id: company.id, programId: activeCompanyProgram.id, journeyId: journey.id } }"
                          class="tw-shadow-app transition-fast tw-border-0 info-card__action tw-rounded-3 tw-fill-current tw-px-2 tw-py-1 tw-mr-2 tw-mb-2 tw-inline-block transition-fast tw-bg-app-deep-blue-11"
                        />
                      </div>
                    </BaseCard>
                  </template>
                </div>


                <div>
                  <!-- some options -->
                </div>
              </template>

            </div>
          </div>

        </transition>
      </div>

    </transition>

  </AppView>
</template>

<script>
import UserPhoto from '@/components/UserPhoto.vue';
// import SwitchInput from '@/components/SwitchInput.vue';

import CompanyProgramLogo from '@/views/Companies/Company/_partials/CompanyProgramLogo.vue';
import EditCompanyProgramName from '@/views/Companies/Company/_partials/EditCompanyProgramName.vue';
import EditCompanyProgramDescription from '@/views/Companies/Company/_partials/EditCompanyProgramDescription.vue';
import EditCompanyProgramDate from '@/views/Companies/Company/_partials/EditCompanyProgramDate.vue';
import EditCompanyProgramColor from '@/views/Companies/Company/_partials/EditCompanyProgramColor.vue';
import EditJourney from '@/views/Companies/Company/_partials/EditJourney.vue';
import ProgramSupportAdmins from '@/views/Companies/Company/_partials/ProgramSupportAdmins.vue';

import companyMixin from '@/mixins/company';
import companyProgramMixin from '@/mixins/companyProgram';

import { toJsDate } from '@/modules/dataHelper';

export default {
  name: 'CustomizeCompanyProgramView',
  components: {
    UserPhoto,
    // SwitchInput,
    CompanyProgramLogo,
    EditCompanyProgramName,
    EditCompanyProgramDescription,
    EditCompanyProgramColor,
    EditCompanyProgramDate,
    EditJourney,
    ProgramSupportAdmins,
  },
  mixins: [companyMixin, companyProgramMixin],
  props: ['id', 'programId'],
  data() {
    return {
      editingName: false,
      editingDescription: false,
      editingColor: false,
      editProgramStartDate: false,
      editProgramEndDate: false,
      companyProgramJourneys: [],
      loadingJourneys: false,
      isRunningProcess: false,
    };
  },
  computed: {
    accountTypes() {
      return this.$store.state.User.accountTypes;
    },
    programStatuses() {
      return this.$store.state.CompanyPrograms.ProgramContext.programStatuses;
    },
    companyProgramStatus() {
      return this.$store.getters.companyProgramStatusName(this.activeCompanyProgram.status);
    },
    programDateRangeIsValid() {
      const taskStartTym = this.$moment(toJsDate(this.activeCompanyProgram.start));
      const taskEndTym = this.$moment(toJsDate(this.activeCompanyProgram.end));

      return taskStartTym.isBefore(taskEndTym);
    },
  },
  methods: {
    async archiveProgram() {
      this.isRunningProcess = true;
      const result = await this.$store.dispatch('archiveCompanyProgram', {
        progid: this.activeCompanyProgram.id,
        reason: '[Admin]',
      });
      this.isRunningProcess = false;

      if (!result) {
        // toast error
        this.$toasted.global.appError();
        return;
      }

      this.$toasted.success('Program archived', {
        duration: 3500,
        position: 'top-right',
      });

      await this.getCompanyProgram();
      await this.$nextTick();
    },
    async deactivateProgram() {
      this.isRunningProcess = true;
      const result = await this.$store.dispatch('deactivateCompanyProgram', {
        progid: this.activeCompanyProgram.id,
        reason: '[Admin]',
      });
      this.isRunningProcess = false;

      if (!result) {
        // toast error
        this.$toasted.global.appError();
        return;
      }

      this.$toasted.success('Program archived', {
        duration: 3500,
        position: 'top-right',
      });

      await this.getCompanyProgram();
      await this.$nextTick();
    },
    async activateProgram() {
      this.isRunningProcess = true;
      const result = await this.$store.dispatch('activateCompanyProgram', {
        progid: this.activeCompanyProgram.id,
        reason: '[Admin]',
      });
      this.isRunningProcess = false;

      if (!result) {
        // toast error
        this.$toasted.global.appError();
        return;
      }

      this.$toasted.success('Program activated', {
        duration: 3500,
        position: 'top-right',
      });

      await this.getCompanyProgram();
      await this.$nextTick();
    },
    async programNameSaved() {
      await this.getCompanyProgram();
      await this.$nextTick();
      this.editingName = false;
    },
    async programColorsSaved() {
      await this.getCompanyProgram();
      await this.$nextTick();
      this.editingColor = false;
    },
    async programDescriptionSaved() {
      await this.getCompanyProgram();
      await this.$nextTick();
      this.editingDescription = false;
    },
    async programLogoSaved() {
      await this.getCompanyProgram();
      await this.$nextTick();
    },
    async programDateSaved(dateType) {
      await this.getCompanyProgram();
      await this.$nextTick();

      if (dateType === 'start') {
        this.editProgramStartDate = false;
      }

      if (dateType === 'end') {
        this.editProgramEndDate = false;
      }
    },
    async deleteProgram() {
      const handleDeleteProgram = async () => {
        const formData = {
          progid: this.activeCompanyProgram.id,
          // companyid: this.company.id,
        };

        const response = await this.$store.dispatch('deleteCompanyProgram', formData);

        if (!response) {
          this.$toasted.global.appError({ errorMessage: 'Could not delete program' });
          return;
        }

        this.$router.push({
          name: 'viewCompany',
          params: {
            id: this.company.id,
          },
        });
      };

      // open dialog modal
      this.$store.commit('openModal', [
        true,
        'dialog',
        false,
        handleDeleteProgram,
        `Are you sure you want to delete Program ${this.activeCompanyProgram.name}?`,
      ]);
    },
    async getCompanyProgramJourneys(company = this.company, companyProgram = this.activeCompanyProgram, refresh = false) {
      this.loadingJourneys = true;
      await this.$nextTick();

      const journeys = await this.$store.dispatch('getProgramJourneys', [company.id, companyProgram.id, refresh]);

      if (journeys) {
        this.companyProgramJourneys = journeys;
      }

      await this.$nextTick();
      this.loadingJourneys = false;
    },
    promptCreateProgramJourney() {
      // open modal
      this.$store.commit('openModal', [true, 'modal']);
    },
  },
  async created() {
    this.errors = { ...this.form };
    // get company
    await this.getCompany();
    await this.$nextTick();

    // assert user company permissions
    if (!this.hasPermission) {
      this.$router.push({
        name: 'app',
      });

      return false;
    }

    await this.getCompanyProgram();

    if (!this.hasProgramPermission) {
      this.$router.push({
        name: 'app',
      });

      return false;
    }

    await Promise.all([
      this.getCompanyProgramJourneys(this.company, this.activeCompanyProgram, true),
    ]);

    await this.$nextTick();

    this.loadingCompany = false;
    return true;
  },
};
</script>

<style>

</style>
